import {Injectable} from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class Common {
    _customerIndex: number = 0;

    constructor(
    ) {}

    deepCopyToExistedObj(oldObj: object, anotherObject: any) {
        // chỉ hoạt động với object có các thuộc tính con
        if (oldObj && typeof oldObj === "object") {
            let newChildObject = Object.prototype.toString.call(oldObj) === "[object Array]" ? [] : {};
            for (let i in oldObj) {
                if (this.isPrimitiveOrDate(oldObj[i])) {
                    if (oldObj[i] instanceof Date) {
                        anotherObject[i] = new Date(oldObj[i].getTime());
                    }
                    else {
                        anotherObject[i] = oldObj[i];
                    }
                }
                else {
                    if (anotherObject[i]) {
                        this.deepCopyToExistedObj(oldObj[i], anotherObject[i]);
                    }
                    else {
                        anotherObject[i] = newChildObject;
                        this.deepCopyToExistedObj(oldObj[i], anotherObject[i]);
                    }
                }
            }
        }
    }

    isPrimitiveOrDate(test) {
        return (this.isPrimitive(test) || test instanceof Date);
    };

    isPrimitive(test) {
        // Check là kiểu dữ liệu nguyên thủy: boolean, nunber, boolean, null, undefined
        return (test !== Object(test));
    };
}
